/* registered at boot rather than after auth: chrome only offers to install the
 * app once a worker with a fetch handler exists. the push flow calls this again
 * for the registration object. */

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null

export async function ensureServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return null
  }
  if (registrationPromise) return registrationPromise

  registrationPromise = navigator.serviceWorker
    .register('/sw.js', { scope: '/' })
    .catch(err => {
      console.warn('sw register failed', err)
      registrationPromise = null
      return null
    })
  return registrationPromise
}

export function isPushSupported(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  )
}
